<template>
  <div class="-mx-[1.5rem] mt-[16px]">
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div style="height: calc(100vh - 230px); overflow-y: scroll;">
        <b-table
          :fields="KATEGORI_TABLE_FIELDS"
          :items="items"
          show-empty
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          thead-tr-class="bg-[#F4F4F4]"
        >
          <template #cell(status)="{ item }">
            <status-badge :status="item.status" />
          </template>
          <template #cell(action)="{ item }">
            <div class="flex items-center justify-center gap-[12px]">
              <template v-if="item.status === 'default'">
                <feather-icon
                  icon="LockIcon"
                  size="18"
                  class="text-[#A8A8A8]"
                  title="Kategori default"
                />
              </template>
              <template v-else>
                <b-form-checkbox
                  :id="`kategori-toggle-${item.id}`"
                  :key="`toggle-${item.id}-${item.is_active}-${item.is_updating}`"
                  :checked="item.is_active"
                  switch
                  class="kategori-toggle"
                  :disabled="Boolean(item.is_updating)"
                  @change="onToggle(item, $event)"
                />
                <button
                  type="button"
                  class="w-[36px] h-[36px] !bg-white border border-solid border-[#E5E5E5] rounded-lg flex items-center justify-center hover:bg-[#F8F9FA] transition-colors p-0 cursor-pointer focus:outline-none"
                  title="Edit Kategori"
                  @click="onEdit(item)"
                >
                  <feather-icon
                    icon="EditIcon"
                    size="18"
                    class="text-black"
                  />
                </button>
              </template>
            </div>
          </template>
        </b-table>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { KATEGORI_TABLE_FIELDS } from '../constants/kategori'
import StatusBadge from './StatusBadge.vue'

export default {
  name: 'KategoriTable',
  components: { StatusBadge },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      KATEGORI_TABLE_FIELDS,
    }
  },
  methods: {
    onToggle(item, isActive) {
      this.$emit('toggle-status', { item, isActive })
    },
    onEdit(item) {
      this.$emit('edit', item)
    },
  },
}
</script>

<style scoped>
.kategori-toggle :deep(.custom-control-input:checked ~ .custom-control-label::before) {
  background-color: #F95031 !important;
  border-color: #F95031 !important;
}
.kategori-toggle :deep(.custom-control-label::before) {
  background-color: #C2C2C2 !important;
  border-color: #C2C2C2 !important;
}
.kategori-toggle :deep(.custom-control-input:disabled ~ .custom-control-label) {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
